
<template>
  <main-layout
    title="Datalink"
    subTitle="Upload and convert your size measurements to the format Virtusize Requires in just a few clicks."
    :displayTitle="displayTitle"
  >
    <template slot="rightElements" />
    <div slot="content">
      <router-view />
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/Main'

export default {
  components: {
    MainLayout
  },
  computed: {
    displayTitle () {
      return this.$route.name !== 'dataLinkDetails'
    }
  }
}
</script>
